import { Defect } from '@/types/Defecten';

import { defectTypeNietInzetbaar } from './defect';

/** Sorts 2 defects based on 'beginTijd'.
 *
 * @param a Defect
 * @param b Defect
 * @returns
 */
export const defectTimeSorter = (a: Defect, b: Defect) => {
  return new Date(a.beginTijd as string).getTime() - new Date(b.beginTijd as string).getTime();
};

/** Sorteer defecten op prioriteit */
export const compareDefectsPriority = (a: Defect, b: Defect) => {
  const priorityScore = (s: number | string | null | undefined) => {
    const n = Number(s);
    return Number.isFinite(n) && n >= 1 && n <= 9 ? n : null;
  };

  const isHandmatig = (d: Defect) => d?.bron === 'HANDMATIG';

  if (isHandmatig(a) !== isHandmatig(b)) return isHandmatig(a) ? -1 : 1;

  const pa = priorityScore(a?.prioriteitscore);
  const pb = priorityScore(b?.prioriteitscore);

  if (pa !== pb) {
    if (pa == null) return 1;
    if (pb == null) return -1;
    return pa - pb;
  }
  return String(a.werkorderId ?? a.eenheidNummer).localeCompare(String(b.werkorderId ?? b.eenheidNummer));
};

/** Sorteer 2 defecten op DefectSoort en nietMeerInzetbaarVanaf
 *
 * @param a Defect
 * @param b Defect
 * @returns
 */
export const defectSorter = (a: Defect, b: Defect) => {
  const getStatusPriority = (defect: Defect) => {
    if (defectTypeNietInzetbaar(defect)) return 2;
    if (defect.soort === 'BEPERKING_IN_TREINDIENST') return 1;
    if (defect.soort === 'GEEN_BEPERKINGEN') return 0;
    return -1;
  };
  if (getStatusPriority(b) === getStatusPriority(a)) return compareDefectsPriority(a, b);

  return getStatusPriority(b) - getStatusPriority(a);
};
